/**
 * OnboardingRpcClient - AtomRpc integration for the customer-facing onboarding
 * surface (`onboarding/*`). Backs the onboarding shell: `onboarding/state`
 * derives the resume step (intake/agent/connections) so a customer returning
 * via their magic link, or after Clerk login, lands on the right step. Clerk
 * session auth via the standard `AuthMiddleware` (NOT admin).
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { OnboardingRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

/**
 * CSRF-guard header the migrated wizard sends alongside the httpOnly
 * `onboarding_session` cookie (CLA-862). Its presence forces a CORS preflight,
 * so the server (see `onboarding-session.middleware.ts`) honors the cookie only
 * when this non-simple header is present. Kept off URLs entirely — the whole
 * point of the CLA-862 migration.
 *
 * @since 1.0.0
 */
export const ONBOARDING_SESSION_HEADER = { "X-Onboarding-Session": "1" } as const;

export class OnboardingRpcClient extends AtomRpc.Tag<OnboardingRpcClient>()(
  "OnboardingRpcClient",
  {
    group: OnboardingRpcs,
    protocol: makeRpcClientLayer(OnboardingRpcs, ONBOARDING_SESSION_HEADER).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
